import React from 'react';

function Footer() {
  const handleFooterClick = (e) => {
    const href = e.currentTarget.getAttribute('href');
    if (href && href.startsWith('#')) {
      e.preventDefault();
      const targetId = href.substring(1);
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        const navbar = document.querySelector('.navbar');
        let navbarHeight = 0;
        if (navbar) {
          const navbarRect = navbar.getBoundingClientRect();
          if (navbar.classList.contains('nav-scroll')) {
            navbarHeight = navbarRect.height || 80;
          } else {
            navbarHeight = navbarRect.height > 0 ? navbarRect.height : 0;
          }
        }

        const rect = targetElement.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const elementTop = rect.top + scrollTop;
        const offsetPosition = elementTop - navbarHeight;
        const finalPosition = Math.max(0, offsetPosition);

        if (typeof window !== 'undefined' && window.ScrollSmoother) {
          try {
            const smoother = window.ScrollSmoother.get();
            if (smoother) {
              smoother.scrollTo(finalPosition, true);
              return;
            }
          } catch (e) {
            // Continuar con scroll nativo si falla
          }
        }

        window.scrollTo({
          top: finalPosition,
          behavior: 'smooth'
        });
      }
    }
  };

  return (
    <footer className="clean-footer crev">
      <div className="container pb-40 pt-40 ontop">
        <div className="row justify-content-between">
          <div className="col-lg-2">
            <div className="logo icon-img-100 md-mb80">
              <img src="/assets/imgs/logo-light.png" alt="" />
            </div>
          </div>
          <div className="col-lg-4">
            <div className="column md-mb50">
              <h6 className="sub-title mb-30">Contacto</h6>
              <h6 className="p-color fw-400">
                Carrera 114 #16-34, Bogotá
              </h6>
              <h6 className="mt-30 mb-15">
                <a href="#0">jugoscitricos@gmail.com</a>
              </h6>
              <h6 className="mt-30 mb-15">
                <a 
                  href="https://wa.me/573115742189?text=Hola, me interesa conocer más sobre sus productos" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="fz-22 main-color"
                >
                  +57 311 5742189
                </a>
              </h6>
              <h6 className="mt-30 mb-15">
                <a 
                  href="https://wa.me/573043829079?text=Hola, me interesa conocer más sobre sus productos" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="fz-22 main-color"
                >
                  +57 304 3829079
                </a>
              </h6>


            </div>
          </div>
          <div className="col-lg-2">
            <div className="column md-mb50">
              <h6 className="sub-title mb-30">Links Utiles</h6>
              <ul className="rest fz-14 opacity-7">
                <li className="mb-15">
                  <a href="#inicio" onClick={handleFooterClick}>Inicio</a>
                </li>
                <li className="mb-15">
                  <a href="#nosotros" onClick={handleFooterClick}>Nosotros</a>
                </li>
                <li className="mb-15">
                  <a href="#cultura" onClick={handleFooterClick}>Cultura</a>
                </li>
                <li className="mb-15">
                  <a href="#experiencias" onClick={handleFooterClick}>Experiencias</a>
                </li>
                <li className="mb-15">
                  <a href="#productos" onClick={handleFooterClick}>Catálogo</a>
                </li>
                <li>
                  <a href="/assets/docs/Cátalogo de Productos - Cítricos Naturales S.A.S.pdf" download>Catálogo PDF</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="column subscribe-minimal">
              <h6 className="sub-title mb-30">Social Media</h6>
              <ul className="rest social-icon d-flex align-items-center">
                <li className="hover-this cursor-pointer">
                  <a href="#0" className="hover-anim">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                </li>
                <li className="hover-this cursor-pointer ml-10">
                  <a 
                    href="https://wa.me/573115742189?text=Hola, me interesa conocer más sobre sus productos" 
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover-anim"
                  >
                    <i className="fab fa-whatsapp"></i>
                  </a>
                </li>
                <li className="hover-this cursor-pointer ml-10">
                  <a href="#0" className="hover-anim">
                    <i className="fab fa-instagram"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="pt-30 pb-30 mt-80 bord-thin-top">
          <div className="text-center">
            <p className="fz-14">
              © 2025 Citricos Naturales S.A.S{'  '}
              <span className="underline main-color">
                <a href="https://themeforest.net/user/UiCamp" target="_blank" rel="noreferrer">
                  
                </a>
              </span>
            </p>
          </div>
        </div>
      </div>
      <div className="circle-blur">
        <img src="/assets/imgs/patterns/blur1.png" alt="" />
      </div>
    </footer>
  );
}

export default Footer;
